/* OP Luxury 2026 - prescription lens configurator.
   Vanilla, no libraries, no dependencies on theme JS. Loaded only on optical PDPs. */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-op-lens]');
  if (!roots.length) return;

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function group(number, precision, thousands, decimal) {
    if (isNaN(number) || number === null) return '0';
    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents, format) {
    var match = format.match(PLACEHOLDER);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = group(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = group(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = group(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = group(cents, 2, ' ', '.'); break;
      default: value = group(cents, 2, ',', '.');
    }
    return format.replace(PLACEHOLDER, value);
  }

  function rootUrl() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  for (var i = 0; i < roots.length; i++) init(roots[i]);

  function init(root) {
    var frames = [];
    try {
      frames = JSON.parse(root.querySelector('[data-op-lens-frames]').textContent) || [];
    } catch (e) { frames = []; }
    if (!frames.length) return;

    var fmt = root.dataset.moneyFormat || 'Rs{{amount}}';
    var form = document.getElementById(root.dataset.formId || '');
    var stepTier = root.querySelector('[data-op-step="tier"]');
    var stepEnh = root.querySelector('[data-op-step="enh"]');
    var stepRx = root.querySelector('[data-op-step="rx"]');
    var rxFields = root.querySelector('[data-op-rxfields]');
    var linesEl = root.querySelector('[data-op-lines]');
    var totalEl = root.querySelector('[data-op-total]');
    var errEl = root.querySelector('[data-op-error]');
    var hintEl = root.querySelector('[data-op-hint]');
    var submitEl = root.querySelector('[data-op-submit]');
    var submitLabel = root.querySelector('[data-op-submit-label]');

    function checked(sel) { return root.querySelector(sel + ':checked'); }
    function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function frameVariantId() {
      var input = form && form.querySelector('.product-variant-id');
      var val = input && input.value;
      if (val) {
        for (var k = 0; k < frames.length; k++) {
          if (String(frames[k].id) === String(val)) return frames[k].id;
        }
      }
      return frames[0].id;
    }

    function framePrice() {
      var id = frameVariantId();
      for (var k = 0; k < frames.length; k++) if (frames[k].id === id) return frames[k].price;
      return frames[0].price;
    }

    function tierSelected() {
      var el = checked('[data-op-tier]');
      if (!el) return null;
      return { id: el.value, price: parseInt(el.dataset.price, 10) || 0, label: el.dataset.label || '' };
    }

    function enhSelected() {
      return all('[data-op-enh]').filter(function (el) { return el.checked; }).map(function (el) {
        return { id: el.value, price: parseInt(el.dataset.price, 10) || 0, label: el.dataset.label || '' };
      });
    }

    function typeSelected() {
      var el = checked('[data-op-type]');
      return el ? el.value : '';
    }

    function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }

    function setError(msg) {
      if (!errEl) return;
      if (msg) { errEl.textContent = msg; errEl.removeAttribute('hidden'); }
      else { errEl.textContent = ''; errEl.setAttribute('hidden', ''); }
    }

    function addLine(label, cents) {
      var row = document.createElement('div');
      row.className = 'op-lens__line';
      var dt = document.createElement('dt');
      dt.textContent = label;
      var dd = document.createElement('dd');
      dd.innerHTML = money(cents, fmt);
      row.appendChild(dt);
      row.appendChild(dd);
      linesEl.appendChild(row);
    }

    function recompute() {
      var type = typeSelected();
      var isRx = type === 'single' || type === 'progressive';

      show(stepTier, isRx);
      all('[data-op-cards]').forEach(function (g) { show(g, isRx && g.dataset.opCards === type); });

      var tier = tierSelected();
      if (tier && isRx) {
        var owner = root.querySelector('[data-op-tier][value="' + tier.id + '"]').closest('[data-op-cards]');
        if (owner && owner.dataset.opCards !== type) {
          root.querySelector('[data-op-tier][value="' + tier.id + '"]').checked = false;
          tier = null;
        }
      }
      if (!isRx && tier) {
        root.querySelector('[data-op-tier][value="' + tier.id + '"]').checked = false;
        tier = null;
      }
      if (!isRx) all('[data-op-enh]').forEach(function (el) { el.checked = false; });

      show(stepEnh, isRx && !!tier);
      show(stepRx, isRx && !!tier);

      var rxEl = checked('[data-op-rx]');
      show(rxFields, !!(rxEl && rxEl.value === 'now'));

      var fp = framePrice();
      var total = fp;
      linesEl.innerHTML = '';
      addLine('Frame', fp);

      if (isRx && tier) {
        addLine(tier.label, tier.price);
        total += tier.price;
        enhSelected().forEach(function (e) { addLine(e.label, e.price); total += e.price; });
      } else if (type === 'zero') {
        addLine('Zero power lenses', 0);
      }

      if (totalEl) totalEl.innerHTML = money(total, fmt);

      var ready = type === 'zero' || (isRx && !!tier);
      if (submitEl) {
        submitEl.disabled = !ready;
        submitEl.classList.toggle('op-lens__submit--ready', ready);
      }
      if (submitLabel) {
        submitLabel.textContent = type === 'zero' ? 'Add frame to cart' : 'Add frame and lenses to cart';
      }
      if (hintEl) {
        if (!type) hintEl.textContent = 'Choose a lens type to continue.';
        else if (isRx && !tier) hintEl.textContent = 'Choose a lens package to continue.';
        else if (type === 'zero') hintEl.textContent = 'Clear plano lenses, fitted before the frame ships. No extra charge.';
        else hintEl.textContent = 'Lenses are cut and fitted by our opticians before dispatch. Allow 5 to 10 working days.';
      }
      setError('');
    }

    function readRx() {
      var out = {};
      all('[data-op-rxf]').forEach(function (el) {
        /* A disabled axis is an axis that has no cylinder to sit on. Reading it
           would put a stale number on the order line. */
        out[el.dataset.opRxf] = el.disabled ? '' : (el.value || '').trim();
      });
      return out;
    }

    /* --------------------------------------------------------------------
       Prescription entry.

       Sphere and cylinder are selects, so they cannot be mistyped. Axis and PD
       still have to be typed, because neither is a short list, so both are held
       to digits as they are entered and pulled into range when the field is
       left. Nothing is corrected mid keystroke beyond dropping characters that
       could never be valid: a shopper typing 145 should not watch the field
       fight them at 1 and again at 14.
       -------------------------------------------------------------------- */

    function axisFor(side) {
      return root.querySelector('[data-op-axis="' + side + '"]');
    }

    /* An axis without a cylinder is meaningless, so the field stays shut until
       there is a cylinder to describe, and empties itself on the way. */
    function syncAxis() {
      all('[data-op-cyl]').forEach(function (sel) {
        var axis = axisFor(sel.dataset.opCyl);
        if (!axis) return;
        var live = (sel.value || '') !== '';
        axis.disabled = !live;
        if (!live) axis.value = '';
      });
    }

    function clampAxis(el) {
      var digits = (el.value || '').replace(/[^0-9]/g, '');
      if (!digits) { el.value = ''; return; }
      var n = parseInt(digits, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 180) n = 180;
      el.value = String(n);
    }

    /* PD is written to the half millimetre and nothing finer. */
    function clampPd(el) {
      var raw = (el.value || '').replace(/[^0-9.]/g, '');
      var bits = raw.split('.');
      if (bits.length > 2) raw = bits[0] + '.' + bits.slice(1).join('');
      if (!raw || raw === '.') { el.value = ''; return; }
      var n = parseFloat(raw);
      if (isNaN(n)) { el.value = ''; return; }
      n = Math.round(n * 2) / 2;
      if (n < 45) n = 45;
      if (n > 80) n = 80;
      el.value = n % 1 === 0 ? String(n) : n.toFixed(1);
    }

    all('[data-op-axis]').forEach(function (el) {
      el.addEventListener('input', function () {
        var cleaned = (el.value || '').replace(/[^0-9]/g, '').slice(0, 3);
        if (cleaned !== el.value) el.value = cleaned;
      });
      el.addEventListener('blur', function () { clampAxis(el); });
    });

    all('[data-op-pd]').forEach(function (el) {
      el.addEventListener('input', function () {
        var cleaned = (el.value || '').replace(/[^0-9.]/g, '');
        var bits = cleaned.split('.');
        if (bits.length > 2) cleaned = bits[0] + '.' + bits.slice(1).join('');
        if (cleaned !== el.value) el.value = cleaned;
      });
      el.addEventListener('blur', function () { clampPd(el); });
    });

    all('[data-op-cyl]').forEach(function (sel) {
      sel.addEventListener('change', syncAxis);
    });

    syncAxis();

    function eye(sph, cyl, axis) {
      return (sph || '0.00') + ' / ' + (cyl || '0.00') + ' / ' + (axis || '0');
    }

    function busy(on) {
      if (!submitEl) return;
      submitEl.disabled = on;
      submitEl.classList.toggle('op-lens__submit--busy', on);
      if (submitLabel && on) submitLabel.textContent = 'Adding to cart';
    }

    function submit() {
      setError('');
      var type = typeSelected();
      if (!type) { setError('Choose a lens type first.'); return; }

      var fh = root.dataset.frameHandle || '';
      var ft = root.dataset.frameTitle || '';
      var items = [];

      if (type === 'zero') {
        items.push({ id: frameVariantId(), quantity: 1, properties: { 'Lenses': 'Zero power lenses requested' } });
      } else {
        var tier = tierSelected();
        if (!tier) { setError('Choose a lens package to continue.'); return; }

        var rxEl = checked('[data-op-rx]');
        var method = rxEl ? rxEl.value : 'whatsapp';
        var props = {
          _frame_handle: fh,
          _frame_title: ft,
          Frame: ft,
          'Rx method': method === 'now' ? 'Entered online' : 'Sending on WhatsApp'
        };

        if (method === 'now') {
          var f = readRx();
          if (!f.r_sph || !f.l_sph || !f.pd) {
            setError('Add the sphere for both eyes and your PD, or choose to send the prescription on WhatsApp.');
            return;
          }
          props['Right eye (SPH / CYL / AXIS)'] = eye(f.r_sph, f.r_cyl, f.r_axis);
          props['Left eye (SPH / CYL / AXIS)'] = eye(f.l_sph, f.l_cyl, f.l_axis);
          props.PD = f.pd;
        }

        items.push({ id: frameVariantId(), quantity: 1, properties: { Lenses: tier.label } });
        items.push({ id: tier.id, quantity: 1, properties: props });

        enhSelected().forEach(function (e) {
          items.push({
            id: e.id,
            quantity: 1,
            properties: { _frame_handle: fh, _frame_title: ft, Frame: ft, 'Added to': tier.label }
          });
        });
      }

      busy(true);
      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            busy(false);
            recompute();
            setError(res.data.description || res.data.message || 'We could not add this to your cart. Please try again.');
            return;
          }
          window.location.href = rootUrl() + 'cart';
        })
        .catch(function () {
          busy(false);
          recompute();
          setError('Something went wrong. Please try again or message us on WhatsApp.');
        });
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-op-lens-shell]')) recompute();
    });
    if (submitEl) submitEl.addEventListener('click', submit);

    // Keep the running total honest when the shopper switches frame variant.
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { recompute(); });
      }
    } catch (e) { /* theme pubsub unavailable, fall through to the listener below */ }

    var info = root.closest('product-info') || document;
    info.addEventListener('change', function (e) {
      if (root.contains(e.target)) return;
      [80, 400, 900].forEach(function (d) { setTimeout(recompute, d); });
    });

    recompute();
  }
})();

